import React, { useEffect, useState } from "react";
import Card from "../Components/BlogCard";
import CardSkeleton from "../Components/CardSkeleton"; // Import the skeleton component
import Footer from "../Components/Footer";
import Navbar from "../Components/Header";
import blobTopLeft from "../Images/tealback.png";

const BlogsPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    let isMounted = true; // Note this flag denotes mount status
    const fetchData = async () => {
      try {
        const response = await fetch("http://localhost:5000/api/blogs");
        const result = await response.json();
        if (isMounted) {
          setData(result);
          setLoading(false); // Set loading to false when data is fetched
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false); // Also handle error state
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Cleanup function to set the flag to false
    };
  }, []);

  return (
    <>
      <div className="">
        <Navbar color={"bg-white text-teal-950"} />
      </div>
      <div
        className="relative bg-teal-500 px-2 pt-5 pb-20 lg:px-10 lg:pt-8 lg:pb-28 h-[90vh]"
        style={{
          backgroundImage: `url(${blobTopLeft})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}
      >
        <div className="relative mx-auto max-w-7xl">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-white sm:text-4xl lg:mt-5">
              Insights & Updates
            </h2>
            <p className="mx-auto mt-3 max-w-3xl text-lg text-white sm:mt-4">
              Stay informed with the latest news and insights from our team.
              Explore our blog to discover how we’re driving innovation and
              excellence in our industry.
            </p>
          </div>

          <div className="mx-6 md:mx-10 mt-12 grid max-w-xl gap-10 lg:max-w-none grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {loading
              ? // Display 3 skeletons while loading
                Array.from({ length: 3 }).map((_, index) => <CardSkeleton key={index} />)
              : data &&
                data.map((post, index) => (
                  <Card
                    key={index}
                    title={post.title}
                    image={post.image}
                    category={post.category}
                    author={post.author}
                    date={post.createdAt}
                    readTime={post.readTime}
                    content={post.description}
                    id={post._id}
                  />
                ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogsPage;
